import React, { Component } from "react";
import logo from './ukvac-logo.png';
import fblogo from './FBsmall.jpg';

import './logo.css';

class Logo extends Component {
  render() {
    return (
        <div className="logo">
        <a href="#/">
          <img src={logo} className="App-logo" alt="logo" />
        </a> 
        
        <div className="Sosh">
        <a href="http://www.facebook.com/ukvac">          
          <img src={fblogo} className="socials" alt="FB" />
        </a>
        </div>
        </div>
    );
  }
}
 
export default Logo;



// WEBPACK FOOTER //
// ./src/Logo.js